function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    for (var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length; length--; ) {
      var key = props[++index];
      if (iteratee(iterable[key], key, iterable) === !1)
        break;
    }
    return object;
  };
}
export {
  createBaseFor as default
};
//# sourceMappingURL=_createBaseFor.js.map
